module.exports = {
  numberProps: ['width', 'height', 'left', 'right', 'top', 'bottom'],
};
